<div class="fileUpload">
  @if (hasError) {
    <mat-error>
      {{ 'FU-FileRequirements' | translate: { extensions: fileRequirementsExtensions } }}
    </mat-error>
  }

  @if (files && files.length < maxFileCount - (alreadySavedFiles?.length || 0)) {
    <div
      class="container"
      #fileUpload
      appDnd
      (fileDropped)="onFileDropped($event)"
      >
      <input
        type="file"
        #fileDropRef
        id="fileDropRef"
        [accept]="accept"
        (change)="fileBrowseHandler($event.target.files)"
        [disabled]="isDisabled"
        multiple
        />
        <img src="assets/images/dnd/ic-upload-file.svg" alt="" />
        <h3>
          {{ 'FU-DragAndDropFileHere' | translate }} {{ 'FU-Or' | translate }} <label for="fileDropRef">{{ 'FU-BrowseForFile' | translate }}</label>
        </h3>
      </div>
    }
    @if (files && files.length < maxFileCount - (alreadySavedFiles?.length || 0)) {
      <div class="bottom fileInfo">
        <span class="bottom__left">
          {{ 'FileExtensions' | translate }} {{ acceptedExtensions.join('/').toUpperCase() }} ({{ 'MaxFileSize' | translate }} 20Mb)
        </span>
      </div>
    }
    <div class="files-list">
      @for (file of files; track file; let i = $index) {
        <div class="single-file">
          <mat-icon>description</mat-icon>
          <div class="info">
            <h4 class="name">
              {{ file?.name }}
            </h4>
            <p class="size">
              {{ formatBytes(file?.size) }}
            </p>
          </div>
          <img src="assets/images/dnd/ic-delete-file.svg" class="delete" width="20px" alt="file" (click)="deleteFile(i)" />
        </div>
      }
    </div>
  </div>
